<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('modification.changeownership.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('modification.title') }} > </span>
            <span class="middle_loc">{{ $t('modification.changeownership.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('modification.changeownership.fields.step_01') }}</h2>
              <p>{{ $t('modification.changeownership.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('modification.changeownership.fields.step_02') }}</h2>
              <p>{{ $t('modification.changeownership.fields.select_service') }}</p>
            </v-flex>
            <v-flex class="step_box step03 active">
              <h2>{{ $t('modification.changeownership.fields.step_03') }}</h2>
              <p>{{ $t('modification.changeownership.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('modification.changeownership.fields.step_04') }}</h2>
              <p>{{ $t('modification.changeownership.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <div class="text-left mb--5 mod__fields__notice d-flex align-center">
              <v-btn icon style="background:#a01c2a; max-width:18px; max-height:18px;" x-small><v-icon x-small color="#fff">mdi-exclamation</v-icon></v-btn>
              <v-spacer class="hidden_lr5"></v-spacer>{{ $t('modification.changeownership.fields.notice_0') }}
            </div>

            <div class="mt-10">
              <v-flex>
                <h3 class="sub_title_box">{{ $t('application.patent.fields.applicants_s') }}</h3>
                <Applicants
                  :receipt_no.sync="receipt_no"
                  :auto_insert="false"
                  ref="applicants"
                />
              </v-flex>
            </div>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-btn
                color="#acb0b3"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoBefore()"
              >{{ $t('common.button.before') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                style="color: #FFF"
                @click="fnGoNextStep()"
              >{{ $t('common.button.next') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Applicants from '@/components/layout/ChangeOwnershipApplicants'

export default {
  name: 'ChangeOwnershipStep3',
  components :{
    Applicants
  },
  data() {
    return {

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',

      receipt_no : this.$route.params.receipt_no,
    }
  },
  mounted(){
    window.scrollTo(0, 0)

    this.fnGetReceipt()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6409'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoBefore(){
      this.$router.push({path:'/modification/changeownership/step2/' + this.receipt_no})
    },
    fnGoNextStep(){
      if (this.$refs.applicants.applicants.length === 0) {
        let option = {
          text : this.$t('component.applicants.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
      } else {
        requestApi({
          url: '/receivings/change/ownership/' + this.receipt_no + '/applicant/submit',
          method: 'PUT',
          callback: (res) => {
            if (res.res_code === '200') {
              this.$router.push({path:'/modification/changeownership/step4/' + this.receipt_no})
            }else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGoNextStep()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },
  }
}
</script>